<template>
  <div>
    <div class="inline-form-group">
      <el-form-item label="Wymagane" :error="errors['required']">
        <el-switch v-model="form['required']" />
      </el-form-item>
      <el-form-item
        label="Pole od krawędzi do krawędzi"
        :error="errors.full_width"
      >
        <el-switch v-model="form.full_width" />
      </el-form-item>
    </div>
    <el-form-item
      label="Nazwa pola"
      :error="errors[addLanguageSuffix('label')]"
    >
      <wysiwyg-input v-model="form[addLanguageSuffix('label')]" />
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['form', 'errors']
}
</script>
